var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 15.333,
    fill: "#FFC2DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 13.467c-2.856-2.942-6.163-1.7-8.21-.389-1.158.742-2.76.742-3.918 0-2.047-1.312-5.354-2.553-8.21.39-6.78 6.983 4.847 20.44 10.169 20.44S39.44 20.45 32.66 13.468z",
    fill: "#EF0554",
    stroke: "#EF0554",
    strokeWidth: 2.225,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHeart);
export default __webpack_public_path__ + "static/media/homeHeart.bc346d469b1e2e09c0dbf8b191baad11.svg";
export { ForwardRef as ReactComponent };